exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notes-container .edit-link[data-v-55e47df9]{margin-left:50px}", ""]);

// exports
